import Const from 'constants';
import {isPlayerOnSinglePositionByParams} from 'helpers/player-helper';

export function getComparisonTypeByNumber(number) {
    number = Number(number);

    if (number === Const.STACKS_NUMBER_TYPE_AT_MOST) {
        return Const.STACKS_TYPE_AT_MOST;
    } else if (number === Const.STACKS_NUMBER_TYPE_AT_LEAST) {
        return Const.STACKS_TYPE_AT_LEAST;
    } else if (number === Const.STACKS_NUMBER_TYPE_EXACTLY) {
        return Const.STACKS_TYPE_EXACTLY;
    }

    return '';
}

export function getStackTypeNumberByType(type) {
    if (type === Const.STACKS_TYPE_AT_LEAST) {
        return Const.STACKS_NUMBER_TYPE_AT_LEAST;
    } else if (type === Const.STACKS_TYPE_AT_MOST) {
        return Const.STACKS_NUMBER_TYPE_AT_MOST;
    } else if (type === Const.STACKS_TYPE_EXACTLY) {
        return Const.STACKS_NUMBER_TYPE_EXACTLY;
    }

    throw new Error('Unknown stack type');
}

export function getPlayersGroupUID(groupName, ...extra) {
    let uid = Const.LP_TEAM_GROUP_PREFIX + groupName;
    extra.map((item) => (uid += Const.LP_ITEM_DELIMITER + item));

    return uid;
}

export function getPlayersSubGroupUID(groupName, ...extra) {
    let uid = Const.LP_SUBGROUP_PREFIX + groupName;
    extra.map((item) => (uid += Const.LP_ITEM_DELIMITER + item));

    return uid;
}

export function addSimplexKeyUnitPrefix(value) {
    return Const.LP_KEY_UNIT_PREFIX + value;
}

export function addSimplexDuplicateUnitPrefix(value) {
    return Const.LP_DUPLICATE_UNIT_PREFIX + value;
}

export function getSimplexUnitName(value) {
    value = Array.isArray(value) ? value : [value];

    return Const.LP_UNIT_PREFIX + value.join(Const.LP_ITEM_DELIMITER);
}

export function getSimplexKeyUnitName(value) {
    value = Array.isArray(value) ? value : [value];

    return addSimplexKeyUnitPrefix(value.join(Const.LP_ITEM_DELIMITER));
}

export function getSimplexDuplicateUnitName(value) {
    value = Array.isArray(value) ? value : [value];

    return addSimplexDuplicateUnitPrefix(value.join(Const.LP_ITEM_DELIMITER));
}

export function addRoleSuffix(incomingValues) {
    const {prefix, role = Const.DEFAULT_MODE} = incomingValues;

    let value = prefix + Const.LP_ITEM_DELIMITER;
    if (Const.CAPTAIN_MODE === role) {
        value += Const.LP_CAPTAIN_PLAYER_POSITION;
    } else if (Const.STAR_MODE === role) {
        value += Const.LP_STAR_PLAYER_POSITION;
    } else if (Const.PRO_MODE === role) {
        value += Const.LP_PRO_PLAYER_POSITION;
    } else {
        value += Const.LP_COMMON_PLAYER_POSITION;
    }

    return value;
}

export function getCSComboVarName(arr) {
    return Const.LP_CS_COMBINATION_PREFIX + arr.join(Const.LP_ITEM_DELIMITER);
}

export function isUnitPrefixInSimplexItem(simplexItem) {
    return simplexItem.charAt(0) === Const.LP_UNIT_PREFIX;
}

export function extractEntityIdFromSimplexItem(simplexItem) {
    const prefix = simplexItem.charAt(0);
    const [entityId] = simplexItem.replace(prefix, '').split(Const.LP_ITEM_DELIMITER);

    return entityId;
}

export function getSimplexUnitNamesByParams(params) {
    const {playerId, playersIndexedById} = params;

    if (!playersIndexedById.hasOwnProperty(playerId) || isPlayerOnSinglePositionByParams(params)) {
        return [getSimplexUnitName(playerId)];
    }

    const {position} = playersIndexedById[playerId];

    return position.map((positionKey) => getSimplexUnitName([playerId, positionKey]));
}

export function convertSimplexRulesToStr(rules) {
    let result = '';

    if (isEmpty(rules)) {
        return result;
    }

    rules = Array.isArray(rules) ? rules : [rules];

    Object.values(rules).map((item) => {
        Object.keys(item.row).map((key) => {
            if (item.row[key] >= 0) {
                result += '+';
            }
            result += item.row[key] + key;
        });

        if (item.hasOwnProperty('type') && item.hasOwnProperty('obj')) {
            result += getComparisonTypeByNumber(item.type);
            result += item.obj;
        }

        result += '\n';
    });

    return result;
}
